// TibberPrice/TibberPriceFetcher.js
// Singleton — does exactly 1 thing: raw I/O via TibberService. No mapping, no business logic.
import tibberService from '../../../services/TibberService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'TibberPriceFetcher';

class TibberPriceFetcher extends CoreBase {
    _name = _name;

    /**
     * @param {string} type - 'quarter' or 'hour'
     * @param {number} dayEms - start of the UTC day in epoch ms
     * @returns {Promise<{rk:string,rate:string,total:number,energy:number,tax:number,ems:number,level:string}[]|null>} null when the request failed
     */
    fetch = async (type, dayEms) => {
        try {
            // agent.get never throws: a failure comes back as null/undefined or a non-2xx response
            const response = await tibberService.getPrices(type, dayEms);
            const ok = response?.status >= 200 && response?.status < 300;
            const items = response?.data?.items;
            if (ok && Array.isArray(items)) return items;

            this.logError('fetch', `no prices for ${type} ${dayEms} — status ${response?.status ?? 'none'}`);
            return null;
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const tibberPriceFetcher = new TibberPriceFetcher();
export default tibberPriceFetcher;
